import React from 'react';
import { ArrowNarrowRightIcon } from '@heroicons/react/outline';
import { Image, Text } from '@ui/atoms';
import { getAuth } from '@services/identity.service';
import { useRouter } from 'next/router';
import routes from '@helpers/routes';

const HomepageFeatureBlocks = ({ loginModal }) => {
  const auth = getAuth();
  const router = useRouter();
  const onClickLaunchAI = () => {
    if (auth) {
      router.push(routes.opportunities)
    }
    else {
      router.push(
          {
            pathname: router.pathname,
            query: { ...router.query, redirect: routes.opportunities },
          },
          undefined,
          { scroll: false }
      );
      loginModal();
    }
  }
  return (
    <div className='bg-bond-analyser-navigate-the-world-of-bonds-with-jiraaf relative w-full'>
       <div className="absolute -top-3 z-10 left-0 w-max 2xl:w-full overflow-hidden h-[40px]"><img src="/images/homepage/wave-pattern.svg" className="w-full h-auto object-cover"/></div>
      <div className="relative w-full flex flex-col gap-8 xl:gap-[56px] max-w-[1440px] mx-auto px-4 xl:px-10 pt-20 pb-20">
          <Text
              content="Navigate the world of Bonds with Jiraaf"
              className="h3-semibold xl:d3-semibold text-basicWhite text-center"
          />
          
        {/* Learn Section */}
        <section className="grid grid-cols-12">
          <h2 className="text-3xl col-span-full xl:col-span-2 py-2 xl:p-2 xl:border-t border-[#509BCE] font-semibold text-left">
            <span className="text-bond-analyser-navigate-the-world-of-bonds-with-jiraaf-each-section-heading h4-semibold xl:h2-semibold">Learn</span>
          </h2>
          <div className="grid grid-cols-2 relative col-span-full xl:col-span-10 bg-bond-analyser-navigate-the-world-of-bonds-with-jiraaf-each-section border border-[#2A3B54] rounded-b-[32px] rounded-r-[32px] p-6 xl:p-8 items-center md:items-start gap-8 shadow-lg">
            <div className="flex-1 flex flex-col gap-3 col-span-full xl:col-span-1">
              <div className="text-basicWhite h5-semibold xl:h4-semibold">Jiraaf AI</div>
              <div className="text-[#B0B8C1] p5-regular xl:p4-regular mb-4">Ask Jiraaf AI anything about Bonds and Indian Finance</div>
              <button 
                className="flex items-center gap-2 px-4 xl:px-5 py-2 bg-basicWhite p4-medium text-primary-500 rounded-full font-medium w-max shadow transition hover:bg-gray-100"
                onClick={onClickLaunchAI}
              >
                Launch Jiraaf AI <ArrowNarrowRightIcon className="w-5 -rotate-45" />
              </button>
            </div>
            <Image src="/images/bond-analyser/jiraaf-ai-feature.svg" alt="Learn Section" className="max-h-[228px] xl:block hidden" />
          </div>
        </section>

        {/* Gain Insights Section */}
        <section className="grid grid-cols-12">
          <h2 className="text-3xl col-span-full xl:col-span-3 pb-2 xl:p-2 xl:border-t border-[#509BCE] font-semibold text-left">
            <span className="text-bond-analyser-navigate-the-world-of-bonds-with-jiraaf-each-section-heading h4-semibold xl:h2-semibold">Gain Insights</span>
          </h2>
          <div className="grid grid-cols-2 bg-bond-analyser-navigate-the-world-of-bonds-with-jiraaf-each-section border border-[#2A3B54] rounded-b-[32px] rounded-r-[32px] col-span-full xl:col-span-9 p-6 xl:p-8 items-center gap-8 shadow-lg">
            <div className="flex-1 flex flex-col gap-3 col-span-1">
              <div className="text-basicWhite h5-semibold xl:h4-semibold">Bond Analyser</div>
              <div className="text-[#B0B8C1] p5-regular xl:p4-regular mb-4">Make informed investment decisions with our powerful Bond Analyser Suite</div>
              <button className="flex items-center gap-2 px-4 xl:px-5 py-2 p4-medium bg-basicWhite text-primary-500  rounded-full font-medium w-max shadow transition hover:bg-gray-100">
                Explore the Suite <ArrowNarrowRightIcon className="w-5 -rotate-45" />
              </button>
            </div>

            <div className="min-h-[200px] w-full invisible col-span-1" />
          </div>
        </section>

        {/* Discover Section */}
        <section className="grid grid-cols-12">
          <h2 className="text-3xl col-span-full xl:col-span-4 pb-2 xl:p-2 xl:border-t border-[#509BCE] font-semibold text-left">
            <span className="text-bond-analyser-navigate-the-world-of-bonds-with-jiraaf-each-section-heading h4-semibold xl:h2-semibold">Discover</span>
          </h2>
          <div className="grid grid-cols-2 bg-bond-analyser-navigate-the-world-of-bonds-with-jiraaf-each-section border border-[#2A3B54] rounded-b-[32px] rounded-r-[32px] col-span-full xl:col-span-8 p-6 xl:p-8 items-center gap-8 shadow-lg">
            <div className="flex-1 flex flex-col gap-3">
              <div className="text-basicWhite h5-semibold xl:h4-semibold">Bond Directory</div>
              <div className="text-[#B0B8C1] p5-regular xl:p4-regular mb-4">Make informed investment decisions with our powerful Bond Analyser Suite</div>
              <button className="flex items-center gap-2 px-4 xl:px-5 py-2 p4-medium bg-basicWhite text-primary-500 rounded-full font-medium w-max shadow transition hover:bg-gray-100">
                Explore the Suite <ArrowNarrowRightIcon className="w-5 -rotate-45" />
              </button>
            </div>
            <Image src="/images/bond-analyser/bond-directory-feature.svg" alt="Learn Section" className="max-h-[228px]" />
          </div>
        </section>
      </div>
    </div>
  );
};

export default HomepageFeatureBlocks;
